const linearSVGRAD=(color)=>{
    
    switch (color) {
        case 'purple':
            return({col1:"#008ac8",col2:"#142846"})
            
            
    
        default:
            return({col1:"#FFFFFF",col2:"#FFFFFF"})
    }
}

const retlinear=(obj)=>{


    return(

        <linearGradient id="paint0_linear_300_1378" x1="35" y1="7" x2="3" y2="32" gradientUnits="userSpaceOnUse">
            <stop stopColor={obj.col1}/>
            <stop offset="1" stopColor={obj.col2}/>    
            </ linearGradient>

    )
}

const SVGstorage=(textsvg)=>{


    switch (textsvg) {
        case 'chatbutton':
            
            return(
                <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="53" height="53" fill="#ffffff" viewBox="0 0 24 24">
                <path  strokeLinecap="round" strokeWidth="2" d="M8.737 8.737a21.49 21.49 0 0 1 3.308-2.724m0 0c3.063-2.026 5.99-2.641 7.331-1.3 1.827 1.828.026 6.591-4.023 10.64-4.049 4.049-8.812 5.85-10.64 4.023-1.33-1.33-.736-4.218 1.249-7.253m6.083-6.11c-3.063-2.026-5.99-2.641-7.331-1.3-1.827 1.828-.026 6.591 4.023 10.64m3.308-9.34a21.497 21.497 0 0 1 3.308 2.724m2.775 3.386c1.985 3.035 2.579 5.923 1.248 7.253-1.336 1.337-4.245.732-7.295-1.275M14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"/>
              </svg>
               
            )
            
        case 'IA':
            return(
                <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="63" height="63" fill="currentColor" viewBox="0 0 24 24">
                <path fillRule="evenodd" d="M4 3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h1v2a1 1 0 0 0 1.707.707L9.414 13H15a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4Z" clipRule="evenodd" />
                <path fillRule="evenodd" d="M8.023 17.215c.033-.03.066-.062.098-.094L10.243 15H15a3 3 0 0 0 3-3V8h2a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-1v2a1 1 0 0 1-1.707.707L14.586 18H9a1 1 0 0 1-.977-.785Z" clipRule="evenodd" />
                </svg>
            )   
            
        case 'online':
            return(


                <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <path fillRule="evenodd" d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm13.707-1.293a1 1 0 0 0-1.414-1.414L11 12.586l-1.793-1.793a1 1 0 0 0-1.414 1.414l2.5 2.5a1 1 0 0 0 1.414 0l4-4Z" clipRule="evenodd"/>
</svg>

            )   
        
        case 'send':
            return(
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z" fill="url(#paint0_linear_300_1378)" />
                <g clipPath="url(#clip0_300_1378)">
                    <path d="M28.3334 11.6667L19.1667 20.8334M28.3334 11.6667L22.5001 28.3334L19.1667 20.8334M28.3334 11.6667L11.6667 17.5L19.1667 20.8334" stroke="#F5F5F5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </g>
                <defs>
                    {
                        retlinear(linearSVGRAD('purple'))
                    }
                    <clipPath id="clip0_300_1378">
                        <rect width="20" height="20" fill="white" transform="translate(10 10)" />
                    </clipPath>
                </defs>
            </svg>


            )    
        default:
            break;
    }
}

export default SVGstorage;